import React, { useState, useCallback } from "react"
import { Flex, Button } from "antd"
import tabStyles from "./index.module.css"
// import CrewMembersPage from "./crewMembers/CrewMembersPage"
// import EquipmentPage from "./equipment"
import { DocumentsAdded } from "./DocumentsAdded"
import { useTranslation } from "react-i18next"
import {SignedDocuments} from "./SignedDocuments"
 
export const DigitalWaiverAndContracts = () => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState("documents_added")
  const handleTabChange = useCallback((tab) => {
    setActiveTab(tab)
  }, [])
 
  return (
    <>
      <Flex gap={4}>
        <Button
          type="text"
          className={`${tabStyles.tabButton} ${activeTab === "documents_added" ? tabStyles.tabButtonActive : tabStyles.tabButtonInactive}`}
          onClick={() => handleTabChange("documents_added")}
        >
          {t("digital_waiver_and_contracts.documents_added")}
        </Button>
        <Button
          type="text"
          className={`${tabStyles.tabButton} ${activeTab === "signed_documents" ? tabStyles.tabButtonActive : tabStyles.tabButtonInactive}`}
          onClick={() => handleTabChange("signed_documents")}
        >
          {t("digital_waiver_and_contracts.signed_documents")}
        </Button>
      </Flex>
      {activeTab === "documents_added" && <DocumentsAdded />}
      {activeTab === "signed_documents" && <SignedDocuments />}
      {/* {activeTab === "crew" && <CrewMembersPage />}
      {activeTab === "equipment" && <EquipmentPage />} */}
    </>
  )
}
 
// export default React.memo(ResourcesContainer)